import { createContext } from 'react';
import { Player } from '../../type';

type playerContext = {
    player?: Player
}

export default createContext<playerContext>({});